// src/component/Pages/Courses.jsx

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../Api/instance";
import { PageHeader } from "../ui/PageHeaders";
import { PremiumCard } from "../ui/PremiumCard";
import { SkeletonCard } from "../ui/Skeletons";
import { styled } from "@mui/material/styles";

const CoursesPageContainer = styled(Box)(({ theme }) => ({
  minHeight: "85vh",
  padding: "40px 0",
  backgroundColor: theme.palette.background.default,
}));

export default function Courses() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const email = localStorage.getItem("userMail");
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(`get/U_ViewCourseName.php`, {
        userId: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
          return;
        }
        if (Array.isArray(response.data)) {
          setData(response.data);
        } else {
          console.error("Response data is not an array:", response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoursesPageContainer>
      <Container>
        {/* Modernized Page Header */}
        <PageHeader 
          title="Our Courses" 
          subtitle="Select a course to view medical topics and mock examination papers"
          onBack={() => navigate("/home")}
        />

        <Row className="g-4">
          {loading ? (
            // Shimmer Loading Skeletons
            Array.from({ length: 4 }).map((_, i) => (
              <Col key={i} xs={12} sm={6} md={4} lg={3}>
                <SkeletonCard />
              </Col>
            ))
          ) : data.length === 0 ? (
            <Col xs={12} style={{ textAlign: "center", padding: "48px 0" }}>
              <Typography variant="body1" color="textSecondary">
                No courses have been added yet.
              </Typography>
            </Col>
          ) : (
            data.map((val) => (
              <Col
                key={val.sno}
                xs={12}
                sm={6}
                md={4}
                lg={3}
              >
                <PremiumCard
                  title={val.course_name}
                  onClick={() => navigate(`/content/${val.sno}`)}
                >
                  <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '140px', backgroundColor: 'var(--color-surface-hover)', borderRadius: '16px', marginBottom: '12px', padding: '16px' }}>
                    <img
                      // src={`https://nursingupdate.in/Nursing/controllers/api/admin/upload/${val.img}`}
                      src={`https://nursingupdate.in/testing_be/controllers/api/admin/upload/${val.img}`}
                      alt={val.course_name}
                      style={{
                        maxHeight: "110px",
                        maxWidth: "100%",
                        objectFit: "contain",
                        borderRadius: "12px",
                      }}
                    />
                  </Box>
                </PremiumCard>
              </Col>
            ))
          )}
        </Row>
      </Container>
    </CoursesPageContainer>
  );
}
